import * as React from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import { Typography } from '@material-ui/core';
import { SectionFieldContainerProps } from '../../typings';
import FieldTitle from './FieldTitle';
import { FieldInputType } from '../../utils/fieldInputType';
import { MediaFieldType } from '../../utils/mediaFileType';
import { mediaFieldStyles } from '../../styles/MediaFieldStyle';
import { matchesMobile } from '../../utils/mediaQuery';

const MediaField: React.FC<SectionFieldContainerProps> = (mediaProps) => {
  const { isMobile, sectionFieldDetails } = mediaProps;
  const { name, isMandatory, fieldInputType, extra } = sectionFieldDetails;
  const restrictPhotoUploadToCamera = extra?.restrictPhotoUploadToCamera ?? false;

  const mediaType = fieldInputType === FieldInputType.Media ? extra?.mediaType ?? MediaFieldType.All : MediaFieldType.Photos;

  const classes = mediaFieldStyles({ mediaType });

  const isMobileDevice = matchesMobile();

  return (
    <div>
      <FieldTitle name={name} isMandatory={isMandatory} />
      <br />
      {mediaType !== MediaFieldType.Documents && (
        <div>
          <div className={isMobile ? classes.mobilePhotoContainer : classes.photoContainer}>
            {/* add photo or media */}
            <div
              className={
                isMobile || isMobileDevice ? `${classes.mobileSize} ${classes.selectCard}` : `${classes.desktopSize} ${classes.selectCard}`
              }
              data-testid={mediaType === MediaFieldType.All ? 'add-media' : 'add-photo'}
            />
            {/* sample photos */}
            <StaticImage
              className={isMobile || isMobileDevice ? classes.mobileSize : classes.desktopSize}
              layout='constrained'
              placeholder='tracedSVG'
              src='../../assets/Photo/sample-photo.png'
              alt='sample photo'
              data-testid='sample-photo'
            />
            {!restrictPhotoUploadToCamera && (
              <StaticImage
                className={isMobile || isMobileDevice ? classes.mobileSize : classes.desktopSize}
                layout='constrained'
                placeholder='tracedSVG'
                src='../../assets/Photo/sample-photo-link-badge.png'
                alt='sample photo with link badge'
                data-testid='sample-photo-link-badge'
              />
            )}
          </div>
          <br />
        </div>
      )}
      {/* add document */}
      {(mediaType === MediaFieldType.Documents || mediaType === MediaFieldType.All) && (
        <div className={isMobile ? classes.mobileDocumentContainer : classes.documentContainer}>
          {mediaType === MediaFieldType.Documents && (
            <div className={classes.addDocumentContainer} data-testid='add-document'>
              <Typography variant='body1' color='primary'>
                Add Document
              </Typography>
              <StaticImage
                className={classes.iconSize}
                layout='constrained'
                placeholder='tracedSVG'
                src='../../assets/Media/icon-add-document.svg'
                alt='add documents icon'
                data-testid='add-document-icon'
              />
            </div>
          )}
          {/* pdf document */}
          <div className={classes.documentFileContainer} data-testid='document-pdf'>
            <div className={classes.documentLabelContainer}>
              <StaticImage
                className={classes.documentIconSize}
                layout='constrained'
                placeholder='tracedSVG'
                src='../../assets/Media/icon-pdf.png'
                alt='pdf icon'
              />
              <Typography variant='body1'>Document.pdf</Typography>
            </div>
            {(isMobile || isMobileDevice) && (
              <StaticImage
                className={classes.iconSize}
                layout='constrained'
                placeholder='tracedSVG'
                src='../../assets/Media/icon-more.svg'
                alt='more icon'
                data-testid='more-icon-pdf'
              />
            )}
            {!(isMobile || isMobileDevice) && (
              <>
                <div className={classes.iconSize}>
                  <StaticImage
                    layout='constrained'
                    placeholder='tracedSVG'
                    src='../../assets/Media/icon-close.svg'
                    alt='close icon'
                    data-testid='close-icon'
                  />
                </div>
              </>
            )}
          </div>
          {/* excel document */}
          <div className={classes.documentFileContainer} data-testid='document-excel-link-badge'>
            <div className={classes.documentLabelContainer}>
              <StaticImage
                className={classes.documentIconSize}
                layout='constrained'
                placeholder='tracedSVG'
                src='../../assets/Media/icon-excel-link-badge.png'
                alt='excel icon with link badge'
              />
              <Typography variant='body1'>Sheets.xlsx</Typography>
            </div>
            {(isMobile || isMobileDevice) && (
              <StaticImage
                className={classes.iconSize}
                layout='constrained'
                placeholder='tracedSVG'
                src='../../assets/Media/icon-more.svg'
                alt='more icon'
                data-testid='more-icon-excel'
              />
            )}
            {!(isMobile || isMobileDevice) && (
              <>
                <div className={classes.iconSize}>
                  <StaticImage
                    layout='constrained'
                    placeholder='tracedSVG'
                    src='../../assets/Media/icon-link-off.png'
                    alt='link off'
                    data-testid='link-off'
                  />
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default MediaField;
